<template>
  <div id="align">
    <form action="" v-on:submit.prevent="onSubmit">
      <input type="text" name="login" v-model="login" placeholder="логин">
      <input type="password" name="password" v-model="pass" placeholder="пароль"  v-on:keyup.enter="tryLogin">
      <div v-on:click="tryLogin" class="button">Войти</div>
    </form>
  </div>
</template>

<script>

  import {AUTH_REQUEST} from '../store/actions/auth'
  export default {
    name: "SignIn",
    data:function(){
      return{
        login:'',
        pass:''
      }
    },
    methods:{
      tryLogin:function(){
        const { login, pass } = this;
        this.$store.dispatch(AUTH_REQUEST, { login, pass }).then(() => {
          this.$router.push('/')
        })
      },
      onSubmit:function(){}
    }
  }
</script>

<style scoped>
  #align{display: flex;align-items: center;justify-content: center;width: 100%;}
form{width: 500px;padding: 20px;background: white;border:3px solid green;}
</style>